import { notFoundComponent } from './notFound.component';

export const notFoundStateName = 'notFound';

export const notFoundState = ($stateProvider, $urlRouterProvider) => {
  'ngInject';

  $stateProvider.state({
    name: notFoundStateName,
    url: '/notFound',
    component: notFoundComponent.name,
  });

  $urlRouterProvider.otherwise('/notFound');
};
